import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSupportAuth } from '../contexts/SupportAuthContext';
import { cabinetPath } from '../lib/domains';

interface SupportProtectedRouteProps {
    children: React.ReactNode;
}

export const SupportProtectedRoute: React.FC<SupportProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated, isLoading } = useSupportAuth();
    const location = useLocation();

    if (isLoading) {
        return <div className="flex justify-center items-center h-screen">Загрузка...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to={cabinetPath('support', '/login')} state={{ from: location }} replace />;
    }

    return <>{children}</>;
};

